import { render, staticRenderFns } from "./DestacadosView.vue?vue&type=template&id=30c19478&scoped=true&"
import script from "./DestacadosView.vue?vue&type=script&lang=ts&"
export * from "./DestacadosView.vue?vue&type=script&lang=ts&"
import style0 from "./DestacadosView.vue?vue&type=style&index=0&id=30c19478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c19478",
  null
  
)

export default component.exports